import { useApi } from "./useApi";
import { Events, dispatch } from "../redux/dispatch";

const CACHE_TTL_MS = 3600 * 3 * 1000;


const CACHE_KEYS = {
  over05HT: "stats:over05HT",
  over05HTOdds: "stats:over05HT-odds",
};

const getCachedStats = (key) => {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return null;

    const cached = JSON.parse(raw);
    if (!cached?.timestamp || cached.data == null) return null;

    if (Date.now() - cached.timestamp > CACHE_TTL_MS) {
      localStorage.removeItem(key);
      return null;
    }

    return cached.data;
  } catch {
    localStorage.removeItem(key);
    return null;
  }
};

const setCachedStats = (key, data) => {
  localStorage.setItem(
    key,
    JSON.stringify({
      timestamp: Date.now(),
      data,
    }),
  );
};

export const useStats = () => {
  const { client } = useApi();
  const notifyError = (
    message = "No fue posible obtener las estadisticas.",
  ) => {
    dispatch(Events.SHOW_ALERT, {
      message,
      type: "ERROR",
    });
  };

  const fetchStats = async (endpoint, cacheKey) => {
    const cached = getCachedStats(cacheKey);
    if (cached) return cached;

    try {
      const stats = await client.get(endpoint);
      if (stats != null) setCachedStats(cacheKey, stats);
      return stats;
    } catch (err) {
      notifyError();
    }
  };

  const getOver05HTStats = () =>
    fetchStats("/v1/stats/over05HT", CACHE_KEYS.over05HT);

  const getOver05HTOddsStats = () =>
    fetchStats("/v1/stats/over05HT-odds", CACHE_KEYS.over05HTOdds);

  return { getOver05HTStats, getOver05HTOddsStats };
};

// this is an example of the data structure that the API returns for the over05HT stats. You can use this as a reference to create TypeScript interfaces or types if needed.
// export interface Root {
//   data: Data
// }

// export interface Data {
//   totalMatches: number
//   finishedMatches: number
//   pendingMatches: number
//   hits: Hits
//   misses: Misses
//   hitRate: number
//   finishedFixtures: FinishedFixture[]
//   pendingFixtures: PendingFixture[]
//   firstGoal: FirstGoal
// }

// export interface Hits {
//   matches: number
//   percent: number
// }

// export interface Misses {
//   matches: number
//   percent: number
//   noHtGoal: NoHtGoal
//   goalBeforeMin16: GoalBeforeMin16
//   missingGoalMinute: MissingGoalMinute
// }

// export interface NoHtGoal {
//   matches: number
//   percent: number
// }

// export interface GoalBeforeMin16 {
//   matches: number
//   percent: number
// }

// export interface MissingGoalMinute {
//   matches: number
//   percent: number
// }

// export interface FinishedFixture {
//   fixtureId: number
//   league: string
//   homeTeam: string
//   awayTeam: string
//   goalsHT: GoalsHt
//   firstGoalMinute?: number
//   over05HtHit: boolean
//   reason?: string
// }

// export interface GoalsHt {
//   home: number
//   away: number
//   total: number
// }

// export interface PendingFixture {
//   fixtureId: number
//   league: string
//   homeTeam: string
//   awayTeam: string
//   timestamp: number
//   status: Status
//   probabilities: Probabilities
// }

// export interface Status {
//   long: string
//   short: string
//   elapsed: any
//   extra: any
// }

// export interface Probabilities {
//   strictVenueOver05: number
//   overallOver05: number
// }

// export interface FirstGoal {
//   averageMinute: number
//   byPeriod: ByPeriod
//   afterMinute: AfterMinute[]
// }

// export interface ByPeriod {
//   "0-15": N015
//   "15-30": N1530
//   "30-45": N3045
//   "45+": N45
// }

// export interface N015 {
//   matches: number
//   percentOfHits: number
// }

// export interface N1530 {
//   matches: number
//   percentOfHits: number
// }

// export interface N3045 {
//   matches: number
//   percentOfHits: number
// }

// export interface N45 {
//   matches: number
//   percentOfHits: number
// }

// export interface AfterMinute {
//   afterMinute: number
//   matches: number
//   percentOfHits: number
//   percentOfFinished: number
// }
